import {
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  SimpleGrid,
} from "@chakra-ui/react";
import { useTranslation } from "TranslationContext";
import { LANGUAGE_DROPDOWN } from "configs/common";
import DownArrow from "components/Icons/InstantIMPageIcons/DownArrow";
import { useAppSelector, useAppDispatch } from "hooks/store/hooks";
import React, { useEffect, useState } from "react";
import { selectColorThemeMode, markUI } from "stores/ui/uiSlice";
import { getUserLanguage, setUserLanguage,setUserlasselectedtLanguage } from "utils/local-storage";

const LanguageDropDown = ({ height, showDropdownArrow }) => {
  const languageMode = getUserLanguage();
  const dispatch = useAppDispatch();
  const colorThemeMode = useAppSelector(selectColorThemeMode);
  const { setLocale } = useTranslation();
  const [language, setLanguage] = useState(LANGUAGE_DROPDOWN[0]);
  useEffect(() => {
    if (languageMode) {
      const currentOption = LANGUAGE_DROPDOWN.find(
        (co) => co.value === languageMode
      );
      setLanguage(currentOption);
      setUserLanguage(currentOption.value);
      setLocale(currentOption.value);
    } else {
      setLocale("pl");
      setUserLanguage("pl");
    }
  }, [languageMode]);

  const handleChangeLanguage = (option) => { 
    setLocale(option.value);
    setLanguage(option);
    setUserLanguage(option.value);
    setUserlasselectedtLanguage(true)
    dispatch(
      markUI({
        language: option.value,
      })
    )
  };

  return (
    <>
      <Menu
        matchWidth
        isLazy
        lazyBehavior="unmount"
        w="20px"
        mb={{ sm: "10px", md: "20px", base: "10px" }}
      >
        <MenuButton
          as={Button}
          w={{ base: "full", md: showDropdownArrow ? "70px" : "50px" }}
          p={showDropdownArrow ? "0px 10px" : 0}
          minW={"10px"}
          h={"50px"}
          borderRadius={"0px"}
          _hover={{ bg: "#00000020" }}
          className="selectLanguage"
        >
          {language.icon}
          {showDropdownArrow && <DownArrow />}
        </MenuButton>
        <MenuList
          zIndex={1002}
          height={height ? height : "auto"}
          overflow="scroll"
          right={"0px"}
          margin={{base:"-70px",md:"-10px"}}
          position={"absolute"}
          //minW={"140px !important"}
          //maxW={"140px !important"}
          borderRadius={"2px"}
          marginTop={"-9px"}
          p={0}
          bg={`${colorThemeMode}_background`}
          boxShadow={"1px 1px 15px rgba(0, 0, 0, .1)"}
        >
          <SimpleGrid columns={{ base: 1 }} spacing={2} width={"270px"} >
          {LANGUAGE_DROPDOWN &&
            LANGUAGE_DROPDOWN.map((option) => (
                  <MenuItem
                    as={Button}
                    key={option.value}
                    borderRadius={"0px"}
                    isActive={option.value === language.value}
                    leftIcon={option.icon}
                    justifyContent={"flex-start"}
                    value={option.value}
                    onClick={() => handleChangeLanguage(option)}
                    overflow="hidden"
                    alignItems={"center"}
                    bgColor={`${colorThemeMode}_background`}
                    color={`${colorThemeMode}_text`}
                    _active={{
                      bgColor: `${colorThemeMode}_tertiary`,
                    }}
                    _hover={{
                      bgColor: `${colorThemeMode}_tertiary`,
                    }}
                  >
                    <Text
                      size={{ base: "xs", md: "sm" }}
                      marginBottom={0}
                      fontWeight="400"
                      overflow="clip"
                      whiteSpace="nowrap"
                      wordBreak="keep-all"
                      textOverflow="ellipsis"
                      ml={"5px"}
                    >
                      {option.title}
                    </Text>
                  </MenuItem>
                ))}
              </SimpleGrid>
        </MenuList>
      </Menu>
    </>
  );
};

export default LanguageDropDown;